import { Classes as BlueprintClasses } from "@blueprintjs/core";
var addedClasses;
(function (addedClasses) {
    addedClasses["DELETE_ICON"] = "delete-icon";
    addedClasses["ACTION_BUTTON"] = "actionButton";
})(addedClasses || (addedClasses = {}));
export const Classes = Object.assign(Object.assign({}, BlueprintClasses), addedClasses);
//# sourceMappingURL=style.js.map